import type { ReactNode } from 'react';

export const symbol_font_download_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M812-62.91 794-80H144q-26.4 0-45.2-18.51Q80-117.01 80-143v-651l-33-33q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l765 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-62.91ZM141-140h593L141-733v593Zm739-676v579q0 20.11-18 27.55-18 7.45-32-6.55-5-5-7-10.22-2-5.21-2-10.78v-583H238q-5.57 0-10.78-2-5.22-2-10.22-7-14-14-6.34-32.5Q218.31-880 238-880h579q25.99 0 44.49 18.8Q880-842.4 880-816ZM628-418 528-518l-47-131h-2l-22 60-43-43 26-68q3-9 10.74-14.5t17.03-5.5H491q10 0 17 5t11 14l109 283Zm-190-19Zm86-86Zm55 142 102 102q6 14-3.5 26.5T651-240q-10 0-17.5-5.6T623-260l-44-121Zm-203 17-38 104q-3.22 8.8-11.28 14.4-8.05 5.6-17.72 5.6-17 0-26-13.5t-3-28.5l110-288 45 45-38 106h144l55 55H376Z"
		/>
	</svg>
);
